// extracted by mini-css-extract-plugin
module.exports = {"menu":"Header_menu__3dvem","activeLink":"Header_activeLink___yIZR"};